import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from './context/AuthContext';
import { useEffect, useState } from 'react';
import api from './core/axiosInstance';

const ProtectedRoute = ({ children }) => {
  const { token } = useContext(AuthContext);
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const validateToken = async () => {
      try {
        if (!token) {
          setIsAuthenticated(false);
          return;
        }

        const response = await api.get(
          '/api/token/line/validate',
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
          localStorage.removeItem('authToken'); // Clear invalid token
        }
      } catch (error) {
        setIsAuthenticated(false);
      }
    };

    validateToken();
  }, [token]);

  if (isAuthenticated === null) {
    return <div>Loading...</div>; // Show a loading state while checking
  }

  return isAuthenticated ? (
    children
  ) : (
    <Navigate to={`/login?redirect=${location.pathname}`} replace />
  );
};

export default ProtectedRoute;
